import { UserService } from 'app/client-core/services/user.service';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'siteconfigtranslation'
})
export class SiteconfigtranslationPipe implements PipeTransform {
  constructor(
    private userService: UserService
  ) {

  }
  transform(value: any): string {
    console.log(value);
    const config = this.userService.getClientSettingsFromLocalStorage(value);
    console.log(config);
    if (config) {
      return config.displayName;
    }
    return '';
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/siteconfigtranslation.pipe.ts